import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';

import { Box, Card, Container, Fab, Link, Paper, Typography } from '@material-ui/core';
import logoARESS from "./ARESS.png"

import { 
    newSociety,
    fetchSociety
 } from "../../../../../../jsx/actions/authAction"

class FacturePreview extends Component {
    state = {  }
    // onImageDownload = async () => {
    //     const canvas = await html2canvas(document.getElementById("section-to-print"));
    //     const dataURL = canvas.toDataURL('image/png');
    //     downloadjs(dataURL, `${this.props.title}.png`, 'image/png');
    // };
    render() {
        const { SOCIETY, title } = this.props;
        return (
            <Container maxWidth="md">
            {/* <Box> */}
                {/* <TitleWithEndAction>
                    <Fab onClick={this.onImageDownload} size="small" color="secondary">
                        <DownloadRounded />
                    </Fab>
                    
                </TitleWithEndAction> */}
                <Paper>
                    <div 
                        id="section-to-print"
                        // style={{padding:"25px 15px 10px"}}
                    >                    
                        <Box 
                            // p={3}
                            style={{ 
                                padding:"0 10px", 
                                position:"relative",
                                minHeight: "1100px", 
                                // border: "1px solid lightgray",
                            }}
                        >
                            {!isEmpty(this.props.SOCIETY) ?
                            <>
                                <Box p={1} 
                                    style={{
                                        backgroundImage: `url(${logoARESS})`, 
                                        backgroundSize: "contain",
                                        backgroundRepeat:"no-repeat",
                                        backgroundPosition:"center",
                                        // margin:"150px", 
                                        // border: "1px solid green", 
                                        opacity:".15",
                                        position: "absolute",
                                        top: "60%",
                                        left: "50%",
                                        /* bring your own prefixes */
                                        transform:"translate(-50%, -60%)",
                                        width:"60%",
                                        height:"60%"
                                    }}
                                />
                                <Box p={1} style={{ display: "flex", alignItems: "center"}}>
                                    <img
                                        src={logoARESS}
                                        style={{height: "120px"}}
                                    />
                                    <Box style={{ lineHeight: "1px"}}>
                                        <Typography variant="caption">{SOCIETY.society_name}</Typography> <br />
                                        <Typography variant="caption">{SOCIETY.society_address}</Typography> <br />
                                        {/* <Typography variant="caption">{SOCIETY.society_address}{SOCIETY.society_address2 && ` - ${SOCIETY.society_address2}`}</Typography> <br /> */}
                                        
                                        <Typography variant="caption">N°IFU {SOCIETY.society_ifu}</Typography> <br />
                                        <Typography variant="caption">{SOCIETY.society_phone}</Typography> <br />
                                        <Typography variant="caption">{SOCIETY.society_phone2}</Typography> <br />
                                        <Typography variant="caption">{SOCIETY.society_email}</Typography> <br />
                                        <Typography variant="caption">
                                            <Link href={SOCIETY.society_website && SOCIETY.society_website} target="_blank">{SOCIETY.society_website}</Link>
                                        </Typography>
                                    </Box>
                                </Box>
                            </>
                            :
                            <>
                                <Box p={1} 
                                    style={{
                                        backgroundImage: `url(${logoARESS})`, 
                                        backgroundSize: "contain",
                                        backgroundRepeat:"no-repeat",
                                        backgroundPosition:"center",
                                        // margin:"150px", 
                                        // border: "1px solid green", 
                                        opacity:".15",
                                        position: "absolute",
                                        top: "60%",
                                        left: "50%",
                                        /* bring your own prefixes */
                                        transform:"translate(-50%, -60%)",
                                        width:"60%",
                                        height:"60%"
                                    }}
                                />
                                <Box p={1} style={{ display: "flex", alignItems: "center"}}>
                                    <img
                                        src={logoARESS}
                                        style={{height: "120px"}}
                                    />
                                    <Box style={{ lineHeight: "1px"}}>
                                        <Typography variant="caption">NOM ENTREPRISE</Typography> <br />
                                        <Typography variant="caption">ADRESSE</Typography> <br />
                                        {/* <Typography variant="caption">{SOCIETY.society_address}{SOCIETY.society_address2 && ` - ${SOCIETY.society_address2}`}</Typography> <br /> */}
                                        
                                        <Typography variant="caption">N°IFU "XXXXXX"</Typography> <br />
                                        <Typography variant="caption">XXXXXXXXX</Typography> <br />
                                        <Typography variant="caption">XXXXXXXXX</Typography> <br />
                                        <Typography variant="caption">email.entreprise@gmail.com</Typography> <br />
                                        {/* <Typography variant="caption">
                                            <Link href={SOCIETY.society_website && SOCIETY.society_website} target="_blank">{SOCIETY.society_website}</Link>
                                        </Typography> */}
                                    </Box>
                                </Box>
                            </>
                            
                            }
                            <Box
                                p={2}
                                style={{ 
                                    
                                    // minHeight: "1000px", 
                                    // border: "1px solid lightgray",
                                    marginBottom: "20px",
                                    height:"100%"
                                }}
                            >
                                {this.props.children}
                            </Box>
                            {!isEmpty(this.props.SOCIETY) ?
                                <Box 
                                    p={1}
                                    className="footer" // important for print
                                    style={{
                                        position: "absolute",
                                        bottom: "5px",
                                        padding: "30px 10px 0",
                                        whiteSpace: "pre",
                                        textAlign: "center",
                                        width: "100%",
                                    }}
                                >
                                    <Typography variant="caption" style={{display: "block"}}>{SOCIETY.society_bottom}</Typography>
                                </Box>
                            :
                                <Box 
                                    p={1}
                                    className="footer" // important for print
                                    style={{
                                        position: "absolute",
                                        bottom: "5px",
                                        padding: "30px 10px 0",
                                        whiteSpace: "pre",
                                        textAlign: "center",
                                        width: "100%",
                                    }}
                                >
                                    <Typography variant="caption" style={{display: "block"}}>INFOS PIED DE PAGE ICI - INFOS PIED DE PAGE ICI - INFOS PIED DE PAGE ICI</Typography>
                                    <Typography variant="caption" style={{display: "block"}}>INFOS PIED DE PAGE ICI</Typography>
                                </Box>
                            }
                        </Box>
                    </div>
                </Paper>
            {/* </Box> */}
            </Container>
        );
    }
}

function mapStateToProps(state){
    return { 
        STATE: state.request,
        SOCIETY: state.society
    }
}

function mapDispatchToProps(dispatch){
    return bindActionCreators({
        newSociety,
        fetchSociety
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(FacturePreview);